import {getBrowserLocales} from "./get-browser-locales";

export function getShortDateFromDateStr(date: string | number, locale?: string[], withDays = false, withHoursAndMinutes = false): string {
  // date: '2021-12-30'
  const toUseLocale = locale?.length ?  locale : getBrowserLocales();
  return new Date(date).toLocaleDateString(
    toUseLocale ,
    {
      year: 'numeric',
      month: 'short',
      day: withDays ? 'numeric': undefined,
      hour: withHoursAndMinutes ? '2-digit' : undefined,
      minute:  withHoursAndMinutes ? '2-digit' : undefined,
    }
  )
}
